import { render, staticRenderFns } from "./attachment-list.vue?vue&type=template&id=283bdb73"
import script from "./attachment-list.vue?vue&type=script&lang=js"
export * from "./attachment-list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/mse/texting-service/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('283bdb73')) {
      api.createRecord('283bdb73', component.options)
    } else {
      api.reload('283bdb73', component.options)
    }
    module.hot.accept("./attachment-list.vue?vue&type=template&id=283bdb73", function () {
      api.rerender('283bdb73', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/components/attachment/attachment-list.vue"
export default component.exports